import { array, shape, string } from "prop-types";

export const contentPropTypes = shape({
  description: array,
  image: string,
  title: string.isRequired,
  url: string,
}).isRequired;

//Only bottom and top ImageAlignments can allow a fixed width
export const imageAlignmentAllowsFixedWidth = (alignment) =>
  ["bottom", "top"].includes(alignment);
